/**
 * IO Exit Feedback — product PDP soft bottom sheet
 * Unpublished preview theme only.
 *
 * Dylan GO 2026-09-28:
 * - Eligibility: ≥15s on PDP AND (meaningful scroll OR product interaction)
 * - Desktop show: exit-intent (mouse leave top) only
 * - Mobile show: internal same-origin nav-away from /products/... (not cart/checkout)
 * - Never dwell auto-show / scroll-up trigger
 * - Suppress: variant mid-select, ATC, cart open, checkout, deco, 5s after sticky/customize/ATC
 * - Never after successful ATC; once per session (sessionStorage)
 * - session_id from localStorage io_exp_sid (same key as sticky)
 * - Events: io_exit_survey_impression / _response / _dismiss
 *   via Shopify.analytics.publish + POST Apps Script (exit_feedback tab)
 */
(function () {
  'use strict';

  var SS_UTM = 'io_exit_feedback_utm';
  var SS_DONE = 'io_exit_feedback_done';
  var SS_LAST = 'io_exit_feedback_last';
  var SS_ATC = 'io_exit_feedback_atc';
  var LS_SID = 'io_exp_sid';
  var SUPPRESS_MS = 5000;
  var ELIGIBLE_DWELL_MS = 15000;
  var NAV_AWAY_IGNORE_MS = 8000;
  var THANKS_MS = 1200;
  // Same anti-junk token as sticky collector — do not rotate
  var COLLECTOR_TOKEN = 'KAkdPOMSMADC4WikFyUz_ci-Sjm3m0m_';

  function safeJsonParse(s) {
    try { return JSON.parse(s); } catch (e) { return null; }
  }

  function nowIso() {
    try { return new Date().toISOString(); } catch (e) { return ''; }
  }

  function readConfig() {
    var el = document.getElementById('io-exit-feedback-config');
    if (!el) return null;
    return safeJsonParse(el.textContent) || null;
  }

  function ensureSessionId() {
    var sid = null;
    try { sid = localStorage.getItem(LS_SID); } catch (e) {}
    if (!sid) {
      sid = 'io_' + Math.random().toString(36).slice(2, 10) + '_' + Date.now().toString(36);
      try { localStorage.setItem(LS_SID, sid); } catch (e2) {}
    }
    return sid;
  }

  function deviceBucket(w) {
    w = Number(w) || 0;
    if (w <= 320) return 'mobile_320';
    if (w <= 375) return 'mobile_375';
    if (w <= 430) return 'mobile_430';
    if (w <= 767) return 'mobile';
    if (w <= 1024) return 'tablet';
    return 'desktop';
  }

  function captureFirstTouchUtms() {
    try {
      if (sessionStorage.getItem(SS_UTM)) return safeJsonParse(sessionStorage.getItem(SS_UTM));
      var p = new URLSearchParams(window.location.search);
      var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
      var out = { landing_page: window.location.href.split('#')[0], captured_at: nowIso() };
      keys.forEach(function (k) {
        out[k] = p.get(k) || '';
      });
      sessionStorage.setItem(SS_UTM, JSON.stringify(out));
      return out;
    } catch (e) {
      return {
        utm_source: '', utm_medium: '', utm_campaign: '', utm_content: '', utm_term: '',
        landing_page: window.location.href.split('#')[0]
      };
    }
  }

  function getUtms() {
    try {
      var raw = sessionStorage.getItem(SS_UTM);
      if (raw) return safeJsonParse(raw) || captureFirstTouchUtms();
    } catch (e) {}
    return captureFirstTouchUtms();
  }

  function isHardPath() {
    var path = (window.location.pathname || '/').toLowerCase();
    if (path === '/' || path === '') return true;
    if (/^\/collections(\/|$)/.test(path)) return true;
    if (/^\/search(\/|$)/.test(path)) return true;
    if (/^\/cart(\/|$)/.test(path)) return true;
    if (/\/checkouts?\b/.test(path) || /\/checkout(\/|$)/.test(path)) return true;
    if (/\/thank[_-]?you/.test(path) || /\/orders?\//.test(path)) return true;
    var b = document.body;
    if (b && b.className && !/\btemplate-product\b/.test(b.className)) return true;
    return false;
  }

  function sessionDone() {
    try { return sessionStorage.getItem(SS_DONE) === '1'; } catch (e) { return false; }
  }

  function markDone() {
    try { sessionStorage.setItem(SS_DONE, '1'); } catch (e) {}
  }

  function atcOccurred() {
    try { return sessionStorage.getItem(SS_ATC) === '1'; } catch (e) { return false; }
  }

  function markAtcSuccess() {
    try { sessionStorage.setItem(SS_ATC, '1'); } catch (e) {}
    markDone();
  }

  function decoModalOpen() {
    var m = document.getElementById('deco-modal');
    return !!(m && m.classList.contains('open'));
  }

  function cartOpen() {
    try {
      if (document.body.classList.contains('cart-open') ||
          document.body.classList.contains('io-cart-open') ||
          document.documentElement.classList.contains('cart-open')) return true;
      var nodes = document.querySelectorAll(
        '#CartDrawer.is-open, #CartDrawer.open, .cart-drawer.is-open, .cart-drawer.open, ' +
        '[data-cart-drawer].is-open, [data-cart-drawer].open, ' +
        'cart-drawer[open], .drawer--cart.is-open, #cart-notification.active'
      );
      return nodes.length > 0;
    } catch (e) { return false; }
  }

  function isMobile() {
    return (window.innerWidth || 0) <= 767 ||
      (window.matchMedia && window.matchMedia('(max-width: 767px)').matches);
  }

  function findPrimaryCta() {
    return document.querySelector('form[action*="/cart/add"] button[type="submit"]') ||
      document.querySelector('button[name="add"]') ||
      document.querySelector('#io-decorate-btn') ||
      document.querySelector('#io-atc-btn') ||
      document.querySelector('.io-product-form [type="submit"]');
  }

  function scrolledPastFold() {
    var cta = findPrimaryCta();
    if (cta) {
      try { if (cta.getBoundingClientRect().bottom < 0) return true; } catch (e) {}
    }
    var fold = window.innerHeight || 0;
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (fold && scrollTop >= fold * 0.5) return true;
    if (document.body.classList.contains('io-sticky-atc-visible')) return true;
    return false;
  }

  /** True if href is same-origin storefront path away from current PDP (not cart/checkout). */
  function isNavAwayFromPdp(anchor) {
    if (!anchor || !anchor.getAttribute) return null;
    var raw = anchor.getAttribute('href');
    if (!raw || raw.charAt(0) === '#') return null;
    var lower = raw.toLowerCase();
    if (lower.indexOf('javascript:') === 0 || lower.indexOf('mailto:') === 0 || lower.indexOf('tel:') === 0) {
      return null;
    }
    if (anchor.target && String(anchor.target).toLowerCase() === '_blank') return null;
    if (anchor.hasAttribute('download')) return null;

    var url;
    try { url = new URL(raw, window.location.href); } catch (e) { return null; }
    if (url.origin !== window.location.origin) return null;

    var curPath = (window.location.pathname || '/').toLowerCase();
    if (!/^\/products\//.test(curPath)) return null;

    var destPath = (url.pathname || '/').toLowerCase();
    if (destPath === curPath) return null;
    if (/^\/cart(\/|$)/.test(destPath)) return null;
    if (/\/checkouts?\b/.test(destPath) || /^\/checkout(\/|$)/.test(destPath)) return null;
    if (/\/thank[_-]?you/.test(destPath) || /\/orders?\//.test(destPath)) return null;

    return url.href;
  }

  function init() {
    captureFirstTouchUtms();
    var config = readConfig();
    var root = document.querySelector('[data-io-ef-root]');
    if (!config || !root) return;
    if (isHardPath()) return;
    if (sessionDone()) return;
    if (atcOccurred()) return; // never after successful ATC

    var collectorUrl = (config.collectorUrl || '').trim();
    var sessionId = ensureSessionId();

    var state = {
      open: false,
      shown: false,
      responded: false,
      dwellOk: false,
      scrolled: false,
      interacted: false,
      engageReason: '',
      trigger: '',
      suppressUntil: 0,
      variantSelecting: false,
      startedAt: Date.now(),
      pendingHref: null,
      pendingNavTimer: null,
      thanksTimer: null
    };

    function eligible() {
      // ≥15s AND (meaningful scroll OR product interaction)
      return state.dwellOk && (state.scrolled || state.interacted);
    }

    function setScrollEngaged() {
      if (state.scrolled) return;
      state.scrolled = true;
      if (!state.engageReason) state.engageReason = 'scroll';
    }

    function setInteracted(reason) {
      if (!state.interacted) {
        state.interacted = true;
        state.engageReason = reason || 'interaction';
      }
    }

    function hardBlocked() {
      if (sessionDone() || state.shown || atcOccurred()) return true;
      if (isHardPath()) return true;
      if (decoModalOpen()) return true;
      if (cartOpen()) return true;
      if (state.variantSelecting) return true;
      if (Date.now() < state.suppressUntil) return true;
      return false;
    }

    function canShow() {
      if (state.open || hardBlocked()) return false;
      if (!eligible()) return false;
      return true;
    }

    function hideSticky() {
      document.body.classList.add('io-exit-feedback-open');
    }

    function restoreSticky() {
      document.body.classList.remove('io-exit-feedback-open');
    }

    function clearPendingNavTimer() {
      if (state.pendingNavTimer) {
        clearTimeout(state.pendingNavTimer);
        state.pendingNavTimer = null;
      }
    }

    function proceedPendingNav() {
      clearPendingNavTimer();
      var href = state.pendingHref;
      state.pendingHref = null;
      if (href) {
        try { window.location.href = href; } catch (e) {}
      }
    }

    function pageType() {
      var m = (document.body.className || '').match(/template-([a-z0-9-]+)/i);
      return m ? m[1] : 'product';
    }

    function buildBasePayload(extra) {
      var utm = getUtms() || {};
      var w = window.innerWidth || 0;
      var payload = {
        event_name: '',
        experiment: 'exit_feedback',
        response: '',
        other_text: '',
        product_id: String((config.product && config.product.id) || ''),
        variant_id: String((config.product && config.product.variantId) || ''),
        product_handle: (config.product && config.product.handle) || '',
        product_title: (config.product && config.product.title) || '',
        product_price: (config.product && config.product.price) || '',
        utm_source: utm.utm_source || '',
        utm_medium: utm.utm_medium || '',
        utm_campaign: utm.utm_campaign || '',
        utm_content: utm.utm_content || '',
        utm_term: utm.utm_term || '',
        session_id: sessionId,
        viewport_width: w,
        device_bucket: deviceBucket(w),
        device: isMobile() ? 'mobile' : 'desktop',
        page_path: window.location.pathname || '',
        atc_occurred: atcOccurred() ? 'true' : 'false',
        engagement: state.engageReason || '',
        dwell_ms: String(Date.now() - state.startedAt),
        trigger: state.trigger || '',
        landing_page: utm.landing_page || window.location.href.split('#')[0],
        referrer: document.referrer || '',
        page_type: pageType(),
        shop: config.shop || '',
        theme_role: config.themeRole || 'unpublished_preview',
        client_ts: nowIso(),
        ts: nowIso()
      };
      if (extra && typeof extra === 'object') {
        Object.keys(extra).forEach(function (k) { payload[k] = extra[k]; });
      }
      return payload;
    }

    function publishEvent(eventName, extra) {
      var payload = buildBasePayload(extra);
      payload.event_name = eventName;
      try {
        sessionStorage.setItem(SS_LAST, JSON.stringify(payload));
      } catch (e) {}
      try {
        window.__IO_EXIT_EVENTS = window.__IO_EXIT_EVENTS || [];
        window.__IO_EXIT_EVENTS.push({ event: eventName, payload: payload, at: nowIso() });
      } catch (e2) {}
      try {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          Shopify.analytics.publish(eventName, payload);
        }
      } catch (e3) {}
      try {
        window.dispatchEvent(new CustomEvent('io:exit_survey', { detail: { event: eventName, payload: payload } }));
      } catch (e4) {}

      if (!collectorUrl) {
        try { console.info('[io-exit-feedback] collector URL empty — event stored locally', eventName, payload); } catch (e5) {}
        return;
      }
      try {
        var body = Object.assign({}, payload, { token: COLLECTOR_TOKEN });
        fetch(collectorUrl, {
          method: 'POST',
          body: JSON.stringify(body),
          keepalive: true,
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' }
        }).catch(function () { /* never block storefront */ });
      } catch (e6) {}
    }

    function showThanksThenClose() {
      var choices = root.querySelector('[data-io-ef-panel-choices]');
      var thanks = root.querySelector('[data-io-ef-thanks]');
      if (choices) choices.hidden = true;
      if (thanks) thanks.hidden = false;
      if (state.thanksTimer) clearTimeout(state.thanksTimer);
      state.thanksTimer = setTimeout(function () {
        closeSheet({ skipDismissEvent: true });
      }, THANKS_MS);
    }

    function openSheet(trigger) {
      if (!canShow()) return false;
      state.open = true;
      state.shown = true;
      state.trigger = trigger || 'unknown';
      markDone();
      hideSticky();
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      void root.offsetWidth;
      root.classList.add('is-open');
      publishEvent('io_exit_survey_impression', { trigger: state.trigger });
      try {
        var focusable = root.querySelector('[data-io-ef-choice]');
        if (focusable) focusable.focus({ preventScroll: true });
      } catch (e) {}
      return true;
    }

    function closeSheet(opts) {
      opts = opts || {};
      if (state.open && !state.responded && !opts.skipDismissEvent) {
        publishEvent('io_exit_survey_dismiss', { trigger: state.trigger || '' });
      }
      if (!state.open) {
        root.hidden = true;
        root.classList.remove('is-open');
        restoreSticky();
        proceedPendingNav();
        return;
      }
      state.open = false;
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      setTimeout(function () {
        if (!state.open) root.hidden = true;
      }, 280);
      restoreSticky();
      markDone();
      proceedPendingNav();
    }

    function recordResponse(response, otherText) {
      if (state.responded) return;
      state.responded = true;
      publishEvent('io_exit_survey_response', {
        response: response || '',
        other_text: otherText || '',
        trigger: state.trigger || ''
      });
      showThanksThenClose();
    }

    function checkEligibility() {
      if (!state.dwellOk && (Date.now() - state.startedAt) >= ELIGIBLE_DWELL_MS) {
        state.dwellOk = true;
      }
      if (scrolledPastFold()) setScrollEngaged();
    }

    function suppress(ms) {
      state.suppressUntil = Date.now() + (ms || SUPPRESS_MS);
      if (state.open) closeSheet({ skipDismissEvent: false });
    }

    // Choice taps → thanks after select
    var otherWrap = root.querySelector('[data-io-ef-other-wrap]');
    var otherInput = root.querySelector('[data-io-ef-other]');
    var otherDone = root.querySelector('[data-io-ef-other-done]');

    root.querySelectorAll('[data-io-ef-choice]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (state.responded || !state.open) return;
        var val = btn.getAttribute('value') || btn.textContent || '';
        root.querySelectorAll('[data-io-ef-choice]').forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
          b.disabled = true;
        });
        if (btn.hasAttribute('data-io-ef-other-btn')) {
          btn.disabled = false;
          if (otherWrap) {
            otherWrap.hidden = false;
            if (otherInput) {
              try { otherInput.focus({ preventScroll: true }); } catch (e) {}
            }
          }
          return;
        }
        recordResponse(val, '');
      });
    });

    if (otherDone) {
      otherDone.addEventListener('click', function () {
        if (state.responded || !state.open) return;
        var note = otherInput ? (otherInput.value || '').trim().slice(0, 200) : '';
        recordResponse('Other', note);
      });
    }
    if (otherInput) {
      otherInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (otherDone) otherDone.click();
        }
      });
    }

    root.querySelectorAll('[data-io-ef-dismiss]').forEach(function (el) {
      el.addEventListener('click', function () { closeSheet(); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && state.open) {
        e.preventDefault();
        closeSheet();
      }
    });

    var SUPPRESS_SEL =
      '#io-decorate-btn, [data-io-sticky-submit], [data-io-sticky-customize], ' +
      '.io-sticky-atc button, .io-sticky-atc a, [data-io-sticky-atc] button, [data-io-sticky-atc] a, ' +
      'button[name="add"], #io-atc-btn, form[action*="/cart/add"] button[type="submit"]';

    var VARIANT_SEL =
      'select[data-io-variant-select], [data-io-size-select], [data-io-require-choice], ' +
      '[data-io-option-select], .io-product-option select, .io-product-option input, ' +
      'form.io-product-form select, form.io-product-form input[type="radio"]';

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      // Checkout links: suppress, never intercept
      var maybeLink = t.closest('a[href]');
      if (maybeLink) {
        var href = maybeLink.getAttribute('href') || '';
        if (/\/checkouts?\b/i.test(href) || /\/checkout(\?|$|#)/i.test(href) || /shop\.app\/checkout/i.test(href)) {
          suppress();
          return;
        }
        if (/^\/cart(\/|$|\?|#)/i.test(href) || /\/cart(\?|$|#)/i.test(href)) {
          suppress();
          // allow cart nav; do not intercept for survey
        }
      }

      if (t.closest(SUPPRESS_SEL)) {
        suppress();
        return;
      }

      // Product interaction: accordion / gallery / options (not ATC)
      if (t.closest('summary')) {
        setInteracted('accordion');
      }
      if (t.closest('.io-product-gallery, [data-io-gallery], .product__media, .io-gallery')) {
        setInteracted('gallery');
      }
      if (t.closest(VARIANT_SEL)) {
        state.variantSelecting = true;
        setInteracted('variant');
        suppress();
        setTimeout(function () { state.variantSelecting = false; }, SUPPRESS_MS);
      }

      // Mobile: intercept internal nav-away from PDP → show sheet once, then proceed
      if (!isMobile()) return;
      if (state.open || hardBlocked() || !eligible()) return;
      var a = t.closest('a[href]');
      if (!a) return;
      if (root.contains(a)) return;
      var destHref = isNavAwayFromPdp(a);
      if (!destHref) return;

      e.preventDefault();
      e.stopPropagation();
      state.pendingHref = destHref;
      clearPendingNavTimer();
      var opened = openSheet('mobile_nav_away');
      if (!opened) {
        proceedPendingNav();
        return;
      }
      state.pendingNavTimer = setTimeout(function () {
        if (state.open) closeSheet();
        else proceedPendingNav();
      }, NAV_AWAY_IGNORE_MS);
    }, true);

    document.addEventListener('focusin', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest(VARIANT_SEL)) {
        state.variantSelecting = true;
        setInteracted('variant_focus');
        suppress();
      }
    }, true);

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest(VARIANT_SEL) || t.matches && t.matches(VARIANT_SEL)) {
        state.variantSelecting = true;
        setInteracted('variant_change');
        suppress();
        setTimeout(function () { state.variantSelecting = false; }, SUPPRESS_MS);
      }
    }, true);

    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.getAttribute) return;
      var action = (f.getAttribute('action') || '').toLowerCase();
      if (action.indexOf('/cart/add') !== -1) {
        suppress();
      }
      if (action.indexOf('/checkout') !== -1) {
        suppress();
      }
    }, true);

    // Successful ATC via fetch /cart/add → permanent never-show
    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function () {
        var args = arguments;
        var url = args[0];
        var u = typeof url === 'string' ? url : (url && url.url) || '';
        var isAdd = u && String(u).indexOf('/cart/add') !== -1;
        if (isAdd) suppress();
        return origFetch.apply(this, args).then(function (res) {
          if (isAdd && res && res.ok) {
            markAtcSuccess();
            if (state.open) closeSheet({ skipDismissEvent: true });
          }
          return res;
        });
      };
    }

    // Desktop show: eligible + exit-intent only
    document.addEventListener('mouseout', function (e) {
      if (isMobile()) return;
      if (!e || e.clientY > 0) return;
      if (e.relatedTarget || e.toElement) return;
      if (!eligible()) return;
      openSheet('desktop_exit_intent');
    });

    var deco = document.getElementById('deco-modal');
    if (deco && window.MutationObserver) {
      new MutationObserver(function () {
        if (decoModalOpen() && state.open) closeSheet();
      }).observe(deco, { attributes: true, attributeFilter: ['class'] });
    }

    // Watch body class for cart-open style flags
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (cartOpen()) {
          suppress();
          if (state.open) closeSheet();
        }
      }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }

    window.addEventListener('pagehide', function () {
      try {
        console.info('[io-exit-feedback] pagehide', {
          eligible: eligible(),
          dwellOk: state.dwellOk,
          scrolled: state.scrolled,
          interacted: state.interacted,
          engageReason: state.engageReason,
          shown: state.shown,
          trigger: state.trigger,
          open: state.open,
          dwell_ms: Date.now() - state.startedAt
        });
      } catch (e) {}
    });

    window.addEventListener('scroll', function () {
      if (scrolledPastFold()) setScrollEngaged();
    }, { passive: true });

    setInterval(function () {
      checkEligibility();
    }, 500);

    checkEligibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.ioExitFeedbackCaptureUtms = captureFirstTouchUtms;
})();
